import { useEffect } from 'react'
import { useInView } from 'react-intersection-observer'

import Toggle from '../Toggle'
import { HeadlineTwo } from 'content-components/_Primatives/Headlines'
import Loader from 'content-components/_Primatives/Loader'
import style from './style.scss'

type Props = {
  children?: React.ReactNode
  filterOptions: { value: string; label: string }[]
  onChangeFilter: (value: string) => void
  selectedFilter: string
  isLoading: boolean
  onLoadMore: () => void
  headlineText: string
}

function SidebarList(props: Props) {
  const [ref, isInView] = useInView({ threshold: 0 })

  const {
    headlineText,
    children,
    filterOptions,
    onChangeFilter,
    selectedFilter,
    isLoading,
    onLoadMore,
  } = props

  useEffect(() => {
    if (isInView && !isLoading) {
      onLoadMore()
    }
  }, [isLoading, isInView])

  return (
    <>
      {children && (
        <>
          <HeadlineTwo className={style.title}>{headlineText}</HeadlineTwo>
          <Toggle
            options={filterOptions}
            value={selectedFilter}
            onChange={onChangeFilter}
          />
          <ul className={style.list}>{children}</ul>
        </>
      )}

      {isLoading && <Loader />}
      <div ref={ref} />
    </>
  )
}

export default SidebarList
